import React, { useState } from 'react';
import ErrorFallback from 'components/ErrorFallback';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
  const [seed, setSeed] = useState(Math.random());
  const reset = (details: unknown) => {
    setSeed(Math.random());
  };
  return (
    <ReactErrorBoundary key={seed} FallbackComponent={ErrorFallback} onReset={reset}>
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
